// iOS Safari keeps a focused input visible above the on-screen keyboard by resizing/panning
// the *visual* viewport (it does not resize or scroll the document). A `position: fixed`
// element stays anchored to the layout viewport, so as the visual viewport pans, the fixed
// element appears to slide out of sync with what's actually on screen unless it tracks
// `visualViewport.offsetTop`/`.height` directly.
//
// Event-driven, not polled: `visualViewport` fires `resize`/`scroll` live as the browser
// tracks the keyboard animation, so listening costs nothing while idle and updates the
// instant the browser changes the viewport — a requestAnimationFrame poll would do the same
// work on every frame regardless of whether anything changed, for no timing benefit.
export function trackVisualViewport(onChange) {
    const vv = window.visualViewport;
    if (!vv)
        return () => { };
    const update = () => onChange({ offsetTop: vv.offsetTop, height: vv.height });
    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
        vv.removeEventListener('resize', update);
        vv.removeEventListener('scroll', update);
    };
}
